import "./card.styles.scss";
import { Grid, Typography } from '@mui/material';
import CheckboxHtml from "../../components/checkbox/checkbox-html.component";
import Button from "../button/button.component";

const Card = (props) =>{
    const queryString = window.location.search;
    const urlParams = new URLSearchParams(queryString);
    const validStrings = [
        "ttm-9mbb-e2m",
        "ttm-8mbb-e2m",
        "ttm-8mbb-e1m",
        "ttm-7mbb-e2m",
        "ttm-7mbb-e1m",
        "ttm-6mbb-e2m",
        "ttm-6mbb-e1m",
        "ttm-5mbb-e2m",
        "ttm-5mbb-e1m",
        "ttm-4mbb-e1m",
        "ttm-umbb-e1m",
        "ttm-umbb-e1m2"
    ]
    const {plan, choice, index, onClick, link, nogreyout, buttononclick, ...others} = props;
    if(!validStrings.includes(plan.code)){
        urlParams.delete("bonus");
    }
    return (
        <Grid container item xs={11} md={4} xl={2.5} {...others}>
            <Grid container item xs={12} className={`card-container ${choice?choice===index?"checked":nogreyout?"":"unchecked":""}`} onClick={onClick}>
                <Grid item xs={12} className='title-box'>
                    <Typography className='title'>{plan.title}</Typography>
                    <CheckboxHtml checked={choice===index} onChange={onClick}></CheckboxHtml>
                </Grid>
                <Grid item xs={12}>
                    <ul style={{marginBottom:"0", marginTop:"1em"}}>
                        {plan.details? plan.details.map((detail, index)=>{
                            return (<li key={index}>{detail}</li>)
                        }):null}
                    </ul>
                </Grid>
            </Grid>
            <Grid item xs={12} className={choice===index?"":"hidden"} >
                {plan.customButtons? 
                    plan.customButtons.map((customButton, index)=>{
                        return (
                            <Button className={index>0?"btn-reverse":""} text={customButton.label} href={`${customButton.link}${window.location.search.replace("?","&")}`} onClick={buttononclick?buttononclick:()=>{}}></Button>
                        )
                    })
                    :<Button text="CONTINUE" href={`${link}/?${urlParams.toString()}&pln=${plan.code}`} onClick={buttononclick?buttononclick:()=>{}}></Button>
                }
            </Grid>
        </Grid>
    )
}

export default Card;